import styled from 'styled-components';
import {EmblaContainer} from "../embla-slider";

export const TariffsBlockWrap = styled.div`

`

export const TariffsBlockHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 64px;

  h2 {
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;

    @media (max-width: 1024px){
      font-size: 32px;
    }

    @media (max-width: 650px){
      text-align: center;
      width: 100%;
      margin-bottom: 36px;
    }

    @media (max-width: 425px){
      margin-bottom: 31px;
      font-size: 20px;
    }
  }

  @media (max-width: 1300px){
    align-items: flex-start;
    margin-bottom: 41px;
  }
  @media (max-width: 650px){
    flex-direction: column;
  }
  @media (max-width: 425px){
    margin-bottom: 33px;
  }
`;

export const TariffsBlockSettings = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1300px){
    flex-direction: column;
    align-items: flex-end
  }
  @media (max-width: 650px){
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }
`;

export const TariffsBlockSelect = styled.div`
  margin-left: 60px;
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0;
    margin-right: 20px;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;

    @media (max-width: 1300px){
      font-size: 18px;
      line-height: 22px;
    }
  }

  @media (max-width: 1300px){
    margin-left: 0;
  }
  @media (max-width: 650px){
    display: none;
  }
`;

export const TariffsBlockContainer = styled.div`
  display: flex;
`;

export const TariffsBlockDescription = styled.div`
  margin-right: 60px;
  padding: 218px 0 60px;

  @media (max-width: 1420px){
    display: none;
  }
`;
export const TariffsBlockDescItem = styled.div`
  font-size: 16px;
  line-height: 19px;
  padding-bottom: 13px;
  padding-right: 11px;
  border-bottom: 1px solid #E0E0E0;
  margin-bottom: 22px;
  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
`;

export const TariffsBlockTariffs = styled.div`
  flex: 1;

  @media (max-width: 1270px){
    width: 100%;
  }

  ${EmblaContainer} {
    justify-content: space-between;
  }
`;

export const TBCard = styled.div`
  padding: 52px 37px 37px;
  border: 1px solid #9B9B9B;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 333px;
  transition: all 0.05s;

  @media (max-width: 1800px){
    padding: 50px 18px 37px;
    width: 24%;
    min-width: 249px;
  }
  @media (max-width: 1420px){
    width: 24%;
    min-width: 280px;
  }
  @media (max-width: 1270px){
    padding: 29px 15px 18px;
    margin-right: 20px;
  }
  @media (max-width: 768px){
    min-width: 257px;
  }
`;

export const TBCardHeader = styled.div`

`;
export const TBCardTitle = styled.div`
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
  height: 58px;
  text-align: center;

  @media (max-width: 1270px){
    font-size: 22px;
    line-height: 26px;
    height: auto;
    margin-bottom: 18px;
  }
`;
export const TBCardPriceOld = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-decoration: line-through;
  color: #C4C4C4;
  text-align: center;
  min-height: 24px;

  @media (max-width: 1270px){
    font-size: 18px;
    line-height: 22px;
  }
`;
export const TBCardPriceCurrent = styled.div`
  text-align: center;
  font-weight: 500;
  font-size: 28px;
  line-height: 34px;

  @media (max-width: 1270px){
    font-size: 24px;
    line-height: 29px;
  }
`;

export const TBCardDescription = styled.div`
  margin: 50px 0 63px;
  width: 213px;

  @media (max-width: 1270px){
    width: 200px;
    margin: 32px 0 50px;
  }
  @media (max-width: 425px){
    margin: 32px 0 30px;
  }
`;
export const TBCardDescItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 19px;
  padding-bottom: 13px;
  border-bottom: 1px solid #E0E0E0;
  margin-bottom: 22px;
  height: 33px;

  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }

  @media (max-width: 1270px){
    line-height: 22px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    max-height: 38px;
  }
`;

export const DITablet = styled.div`
  display: none;

  @media (max-width: 1420px){
    display: block;
  }
`;

export const TBCardOrder = styled.div`
  width: 100%;

  @media (max-width: 1800px){
    width: 194px;
  }
  @media (max-width: 1270px){
    width: 100%;
  }

  button {
    width: 100%;
    font-weight: 700;
    height: 60px;

    @media (max-width: 1024px){
      height: 56px;
    }
    @media (max-width: 768px){
      background-color: #FFCD00;
      font-size: 22px;
      line-height: 26px;
    }
  }
`;


